import Icon from './Icon.jsx';
import styles from './EmptyState.module.scss';

export default function EmptyState({ icon = 'card', title, children, action }) {
  return (
    <div className={styles.empty}>
      <span className={styles.icon} aria-hidden="true">
        <Icon name={icon} size={30} />
      </span>
      <h2>{title}</h2>
      {children ? <p>{children}</p> : null}
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
}
